import { Region } from '@moonpig/web-core-types'
import { getCardVariantIdsEnabled } from '@moonpig/web-shared-products'
import { GetExperiment } from '@moonpig/web-core-eppo/server'
import { SearchFeatures } from '../types/searchFeatures'
import {
  getGalleryPageSize,
  isPaginationExperimentVariant,
} from '../../utils/getGalleryPageSize/getGalleryPageSize'

type Experiments = {
  [key: string]: string | undefined
}

export type LoadFeaturesProps = {
  region: Region
  experiments: Experiments
  getFlag: GetExperiment
}

const getExperimentKvp = (experiments: Experiments, key: string) => {
  if (
    experiments[key]?.toLowerCase() === 'enabled' ||
    experiments[key]?.toLowerCase() === 'variant'
  ) {
    return `${key}=true`
  }
  if (experiments[key]?.toLowerCase() === 'original') {
    return `${key}=false`
  }
  return ''
}

export const loadFeatures: (props: LoadFeaturesProps) => SearchFeatures = ({
  experiments,
  getFlag,
}) => {
  const showCollageMaker = getFlag('search-show-collage-maker', {
    fallback: true,
  })

  const cardVariants = getCardVariantIdsEnabled()

  const experimentValues = [
    'search-use-new-ia-index=true',
    getExperimentKvp(experiments, 'search-use-age-selection-ux-v2'),
  ]
    .filter(Boolean)
    .join('&')

  const galleryPageSize = getGalleryPageSize(
    isPaginationExperimentVariant(experiments['search-use-pagination']),
  )

  const multiBuyExperimentEnabled =
    experiments['christmas-multi-buy']?.toLowerCase() === 'variant'

  return {
    searchUseNewIaIndex: true,
    showCollageMaker,
    cardVariants,
    experimentValues,
    nbaAlgorithm: 'NBA_6',
    galleryPageSize,
    multiBuyExperimentEnabled,
  }
}
